module.exports = __webpack_public_path__ + "img/navarra.19fd6866.png";